import { render } from "./ChangePasswordModal.vue?vue&type=template&id=4d7e8a8a"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ChangePasswordModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d7e8a8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d7e8a8a', __exports__)) {
    api.reload('4d7e8a8a', __exports__)
  }
  
  module.hot.accept("./ChangePasswordModal.vue?vue&type=template&id=4d7e8a8a", () => {
    api.rerender('4d7e8a8a', render)
  })

}


export default __exports__